import { Container, Stack, Typography } from "@mui/material";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";

export const LoanAppChannelInfo = () => {
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);

    const createRowInfo = (description: string, value: string) => {
        return (
            <Typography variant="body1" component={"span"} sx={{
                my: 1
            }}>
                {description}:{" "}
                <Typography variant="body1" component={"span"} sx={{
                    fontWeight: 600
                }}>
                    {value}
                </Typography>
            </Typography>
        );
    };

    return (
        <Container maxWidth="xs" sx={{ mb: 3, minWidth: "250px" }}>
            <Stack spacing={3}>
                <Typography
                    variant="body1"
                    sx={{
                        textAlign: "center",
                        fontWeight: 600,
                        color: "#528CD6"
                    }}>
                    Canal
                </Typography>
                {createRowInfo("ID canal", applicationSelected.channel_id)}
                {createRowInfo("Detalle canal", applicationSelected.detail_channel)}
                {/* {createRowInfo("Director sucursal", "Francisco Pérez")} */}
                {/* {createRowInfo("Ejecutivo sucursal", "Pedro Jiménez")} */}
                {createRowInfo("Correo ejecutivo", applicationSelected.assigned_partner_email)}
                {/* {createRowInfo("Teléfono", "555 98723423")} */}
            </Stack>
        </Container>
    );
};
